import { createRootRouteWithContext, Outlet, useMatchRoute } from "@tanstack/react-router";
import { useBeforeunload } from "react-beforeunload";
import { useSelector } from "react-redux";
import styled from "styled-components";

import LoginModal from "@/components/LoginModal";
import SaveButton from "@/components/SaveButton";
import VersionPicker from "@/components/VersionPicker";
import GlobalStyle from "@/styles/GlobalStyle";
import type { RouterContext } from "@/router";
import { anyUnsavedChangesSelector } from "@/state";

const Wrapper = styled.div`
    min-height: 100%;
    display: grid;
    grid-template-rows: auto 1fr auto;
    grid-template-columns: 100%;
`;

const Header = styled.div`
    display: flex;
    gap: 1rem;
    align-items: center;
    margin-bottom: 1rem;
`;

const Footer = styled.footer`
    border-top: 1px solid #ccc;
    padding: 10px 0;
    display: grid;
    grid-template-columns: auto auto;
    justify-content: space-around;
    margin-bottom: 3rem;

    img {
        width: 320px;
        object-fit: contain;
        height: 1.5rem;
    }
`;

function App() {
    const anyUnsaved = useSelector(anyUnsavedChangesSelector);
    const matchRoute = useMatchRoute();
    const versionMatch = matchRoute({ to: "/$version", fuzzy: true });
    useBeforeunload(() => {
        if (anyUnsaved) {
            return "You have unsaved changes";
        }
        return;
    });
    return (
        <Wrapper>
            <Header>
                <h1>Translator</h1>
                <VersionPicker />
                {versionMatch && <SaveButton showReset />}
            </Header>
            <main>
                <Outlet />
            </main>
            <Footer>
                <img alt="logo" src="/static/TalentMiles-logo-liggande.png" width="1800" height="363" />
                <div>© TalentMiles</div>
            </Footer>
            <LoginModal />
            <GlobalStyle />
        </Wrapper>
    );
}

export const Route = createRootRouteWithContext<RouterContext>()({
    component: App,
});
